import React, { useState, useEffect } from 'react';
import { func, string, element, shape, arrayOf } from 'prop-types';
import classNames from 'classnames';
import Selector from 'propulsion-rc-v2/lib/selector';
import './SelectionCards.scss';

/**
 * SelectionCards
 * Selection cards with variable content
 * @component
 * @param {Object} props contains items, name, onClick, and loanType
 * @param {Object} props.loanType default card to select
 * @param {Object} props.onClick click handler to update selection
 * @param {Object} props.items list of cards to show and their details
 * @param {Object} props.name name used to group these radio buttons
 * @returns {JSX.Element}
 */
const SelectionCards = ({ items, name, onClick, loanType }) => {
  /**
   * we are reducing on items to generate selectionDefaults and initialSelection
   * for each id an entry is created in the returned objects
   * initialSelection ex:
   * {
   *  [individual]: false
   *  [joint]: false
   * }
   * selectionDefaults ex:
   * {
   *  [individual]: true
   *  [joint]: false
   * }
   */
  const [selection, setSelection] = useState({});
  const [initialSelection, selectionDefaults] = items.reduce(
    ([accInitialSelection, accSelectionDefaults], { id }) => {
      return [
        {
          ...accInitialSelection,
          [id]: id === loanType,
        },
        {
          ...accSelectionDefaults,
          [id]: false,
        },
      ];
    },
    [{}, {}]
  );

  useEffect(() => {
    setSelection(initialSelection);
  }, [items, loanType]);

  const handleClick = (e, id) => {
    setSelection({
      // here we are setting all ids to false
      ...selectionDefaults,
      // we are setting the selected id to true
      [id]: true,
    });
    onClick(e);
  };
  const cards = items.map(({ id, value, content }) => (
    <li key={id}>
      <Selector
        name={name}
        className={classNames('SelectionCard', { 'SelectionCard--selected': selection[id] })}
        selected={!!selection[id]}
        value={value}
        onClick={e => {
          handleClick(e, id);
        }}
      >
        <div className="SelectionCard-iconContainer">
          <span className="SelectionCard-icon"></span>
        </div>
        <div className="SelectionCard-contentContainer">{content}</div>
      </Selector>
    </li>
  ));
  return (
    <fieldset>
      <legend />
      <ul className="SelectionCards">{cards}</ul>
    </fieldset>
  );
};

SelectionCards.propTypes = {
  name: string,
  onClick: func.isRequired,
  loanType: string,
  items: arrayOf(
    shape({
      id: string.isRequired,
      content: element,
      value: string,
    })
  ),
};

SelectionCards.defaultProps = {
  name: '',
  loanType: '',
};

export default SelectionCards;

